import React from 'react';
import { useCompanyContext } from '../../../contexts/Company';
import { useLinesContext } from '../../../contexts/Lines';
import Stepper from '../../../components/Onboarding/BuildingBlocks/OnboardingWrapper';
import PageLayout from '../../../components/Onboarding/Product/Name';

export default function ProductName() {
  const { business } = useCompanyContext();
  const { products } = useLinesContext();

  return (
    <Stepper
      title={'Give this product a name.'}
      subtitle={
        <span>
          <b>Pro tip:</b> Choose a name you will recognize in the future. You
          can edit this name later.
        </span>
      }
      hideContent={!(products && business)}
      headerWidth={900}
      contentWidth={900}
    >
      <PageLayout />
    </Stepper>
  );
}
